import { render } from "./ManageUser.vue?vue&type=template&id=6f152816&scoped=true"
import script from "./ManageUser.vue?vue&type=script&lang=js"
export * from "./ManageUser.vue?vue&type=script&lang=js"

import "./ManageUser.vue?vue&type=style&index=0&id=6f152816&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f152816"]])

export default __exports__